/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GenderEnum } from './genderEnum';


/**
 * Lightweight patient serializer for calendar list views.  Includes organizations (needed by PatientChipComponent) via StringRelatedField which uses the prefetch cache. Excludes treatment_types to avoid per-patient queries.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface CalendarPatient { 
    patientId: string;
    firstName?: string;
    lastName?: string;
    gender: GenderEnum;
    organizations: Array<string>;
}
export namespace CalendarPatient {
}

export const CalendarPatient_patientId_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(7),];

export const CalendarPatient_firstName_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const CalendarPatient_lastName_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const CalendarPatient_gender_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarPatient_organizations_Validators: ValidatorFn[] =
    [  Validators.required, ];


